/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    ChangeTransactionPaymentTypeBody,
    EditTransactionNoteBody,
    EditTransactionProcessingFeeBody,
    FinishManualRefundBody,
    GetTransactionsParams,
    RequestStatusResponseResponse,
    TransactionsSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get transactions matching the filters
 */
export const getTransactions = (params?: GetTransactionsParams, signal?: AbortSignal) => {
    return customInstance<TransactionsSuccessResponseResponse>({
        url: `/transactions`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetTransactionsQueryKey = (params?: GetTransactionsParams) => {
    return [`/transactions`, ...(params ? [params] : [])] as const;
};

export const getGetTransactionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getTransactions>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTransactionsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTransactionsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactions>>> = ({ signal }) =>
        getTransactions(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTransactions>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactions>>>;
export type GetTransactionsQueryError = APIErrorResponseResponse;

/**
 * @summary Get transactions matching the filters
 */

export function useGetTransactions<
    TData = Awaited<ReturnType<typeof getTransactions>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTransactionsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTransactionsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit the note attached to a transaction's payment_info
 */
export const editTransactionNote = (
    id: number,
    editTransactionNoteBody: EditTransactionNoteBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/transactions/${id}/note`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: editTransactionNoteBody,
    });
};

export const getEditTransactionNoteMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTransactionNote>>,
        TError,
        { id: number; data: EditTransactionNoteBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editTransactionNote>>,
    TError,
    { id: number; data: EditTransactionNoteBody },
    TContext
> => {
    const mutationKey = ['editTransactionNote'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editTransactionNote>>,
        { id: number; data: EditTransactionNoteBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editTransactionNote(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditTransactionNoteMutationResult = NonNullable<
    Awaited<ReturnType<typeof editTransactionNote>>
>;
export type EditTransactionNoteMutationBody = EditTransactionNoteBody;
export type EditTransactionNoteMutationError = APIErrorResponseResponse;

/**
 * @summary Edit the note attached to a transaction's payment_info
 */
export const useEditTransactionNote = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTransactionNote>>,
        TError,
        { id: number; data: EditTransactionNoteBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editTransactionNote>>,
    TError,
    { id: number; data: EditTransactionNoteBody },
    TContext
> => {
    const mutationOptions = getEditTransactionNoteMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Change a transaction's payment type between same-fee cash methods
 */
export const changeTransactionPaymentType = (
    id: number,
    changeTransactionPaymentTypeBody: ChangeTransactionPaymentTypeBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/transactions/${id}/paymentType`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: changeTransactionPaymentTypeBody,
    });
};

export const getChangeTransactionPaymentTypeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof changeTransactionPaymentType>>,
        TError,
        { id: number; data: ChangeTransactionPaymentTypeBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof changeTransactionPaymentType>>,
    TError,
    { id: number; data: ChangeTransactionPaymentTypeBody },
    TContext
> => {
    const mutationKey = ['changeTransactionPaymentType'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof changeTransactionPaymentType>>,
        { id: number; data: ChangeTransactionPaymentTypeBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return changeTransactionPaymentType(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ChangeTransactionPaymentTypeMutationResult = NonNullable<
    Awaited<ReturnType<typeof changeTransactionPaymentType>>
>;
export type ChangeTransactionPaymentTypeMutationBody = ChangeTransactionPaymentTypeBody;
export type ChangeTransactionPaymentTypeMutationError = APIErrorResponseResponse;

/**
 * @summary Change a transaction's payment type between same-fee cash methods
 */
export const useChangeTransactionPaymentType = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof changeTransactionPaymentType>>,
        TError,
        { id: number; data: ChangeTransactionPaymentTypeBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof changeTransactionPaymentType>>,
    TError,
    { id: number; data: ChangeTransactionPaymentTypeBody },
    TContext
> => {
    const mutationOptions = getChangeTransactionPaymentTypeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Edit the processing fee on a transaction (superadmin only)
 */
export const editTransactionProcessingFee = (
    id: number,
    editTransactionProcessingFeeBody: EditTransactionProcessingFeeBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/transactions/${id}/processingFee`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: editTransactionProcessingFeeBody,
    });
};

export const getEditTransactionProcessingFeeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTransactionProcessingFee>>,
        TError,
        { id: number; data: EditTransactionProcessingFeeBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editTransactionProcessingFee>>,
    TError,
    { id: number; data: EditTransactionProcessingFeeBody },
    TContext
> => {
    const mutationKey = ['editTransactionProcessingFee'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editTransactionProcessingFee>>,
        { id: number; data: EditTransactionProcessingFeeBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editTransactionProcessingFee(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditTransactionProcessingFeeMutationResult = NonNullable<
    Awaited<ReturnType<typeof editTransactionProcessingFee>>
>;
export type EditTransactionProcessingFeeMutationBody = EditTransactionProcessingFeeBody;
export type EditTransactionProcessingFeeMutationError = APIErrorResponseResponse;

/**
 * @summary Edit the processing fee on a transaction (superadmin only)
 */
export const useEditTransactionProcessingFee = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTransactionProcessingFee>>,
        TError,
        { id: number; data: EditTransactionProcessingFeeBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editTransactionProcessingFee>>,
    TError,
    { id: number; data: EditTransactionProcessingFeeBody },
    TContext
> => {
    const mutationOptions = getEditTransactionProcessingFeeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Mark a cash transaction as finished for manual refund
 */
export const finishManualRefund = (id: number, finishManualRefundBody: FinishManualRefundBody) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/transactions/${id}/finishManualRefund`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: finishManualRefundBody,
    });
};

export const getFinishManualRefundMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof finishManualRefund>>,
        TError,
        { id: number; data: FinishManualRefundBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof finishManualRefund>>,
    TError,
    { id: number; data: FinishManualRefundBody },
    TContext
> => {
    const mutationKey = ['finishManualRefund'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof finishManualRefund>>,
        { id: number; data: FinishManualRefundBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return finishManualRefund(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FinishManualRefundMutationResult = NonNullable<
    Awaited<ReturnType<typeof finishManualRefund>>
>;
export type FinishManualRefundMutationBody = FinishManualRefundBody;
export type FinishManualRefundMutationError = APIErrorResponseResponse;

/**
 * @summary Mark a cash transaction as finished for manual refund
 */
export const useFinishManualRefund = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof finishManualRefund>>,
        TError,
        { id: number; data: FinishManualRefundBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof finishManualRefund>>,
    TError,
    { id: number; data: FinishManualRefundBody },
    TContext
> => {
    const mutationOptions = getFinishManualRefundMutationOptions(options);

    return useMutation(mutationOptions);
};
